// import
import SimpleLightbox from "simplelightbox";

new SimpleLightbox('.gallery a', {
	'closeText': '<i class="bi bi-x"></i>',
	'navText': ['<i class="bi bi-chevron-left"></i>','<i class="bi bi-chevron-right"></i>']
});